/** The search input's placeholder when the consumer gives none: Explore's filter menu copy. */
export const DEFAULT_SEARCH_PLACEHOLDER = "Search filter";

/**
 * How long a category's sub-menu stays open after the pointer leaves its row, in a scrolling menu. The list's
 * scrollbar overlays the rows' right edge, between a row and its sub-menu, so without it crossing the scrollbar
 * closes the sub-menu before the pointer reaches it. Entering the sub-menu cancels the close.
 */
export const SCROLLING_SUB_MENU_CLOSE_DELAY_MS = 150;
